import { EntityAttachmentsButton } from '@Components/Attachments/EntityAttachmentsButton';
import { PrintOptionsMenu } from '@Modules/Documents';
import { Button, ContextMenu, defaultIconSize } from '@synqo/frontend-component-library';
import { IconBan, IconCurrencyEuro, IconDotsVertical } from '@tabler/icons-react';
import { type ReactNode } from 'react';
import { type InvoiceActions } from './useInvoiceActions';

// @ai-generated 2026-09-18T07:55:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5

export function invoiceActionItems(actions: InvoiceActions, i18n: (text: string) => string): ReactNode[] {
    return [
        actions.canApprove && (
            <Button key="approve" appearance="filled" onClick={actions.approvalModal.open} variant="secondary">
                Freigeben
            </Button>
        ),
        actions.canCollect && (
            <Button
                key="cash_payment"
                appearance="filled"
                onClick={actions.cashPaymentModal.open}
                locked={!actions.canCollect}
                tooltip={actions.collectionTooltip}
                variant="secondary"
            >
                <IconCurrencyEuro size={defaultIconSize} />
                &nbsp;{i18n(actions.collectionActionText)}
            </Button>
        ),
    ];
}

export function invoiceMenuItems(actions: InvoiceActions, isEditing: boolean): ReactNode[] {
    return [
        <PrintOptionsMenu key="print_menu" {...actions.printOptionsInfo} disabled={isEditing} />,
        actions.canReadAttachments && (
            <EntityAttachmentsButton
                key="attachments"
                attachmentsInfo={actions.attachmentsInfo}
                canUpload={actions.canManageAttachments}
                canDownload={actions.canDownloadAttachments}
                canDelete={actions.canManageAttachments}
            />
        ),
        actions.canCancel && (
            <ContextMenu key="ctx_cancel_option" icon={IconDotsVertical} name={'context_menu'}>
                <Button appearance="filled" onClick={actions.cancellationModal.open} locked={isEditing}>
                    <IconBan size={defaultIconSize} />
                    &nbsp;Stornieren
                </Button>
            </ContextMenu>
        ),
    ];
}
